/**
 * Constants: gridPageSizes, max is 100
 * Removed greater values because MIT version of Datagrid does not support it
 */
export const gridPageSizes = [25, 50, 100]; //[25, 50, 100, 250, 500]
